/**
 * EstimateStatusBadge - T180
 *
 * Sprint 006 (A2): shared StatusBadge + tone role-map (converted keeps
 * its purple as the one 'special' tone).
 */
import { StatusBadge, type StatusTone } from '../ui';
import { type EstimateStatus, statusLabels } from '../../hooks/useEstimates';

export const ESTIMATE_STATUS_TONES: Record<EstimateStatus, StatusTone> = {
  draft: 'neutral',
  sent: 'info',
  accepted: 'success',
  rejected: 'danger',
  expired: 'warning',
  converted: 'special',
};

interface EstimateStatusBadgeProps {
  status: EstimateStatus;
  size?: 'sm' | 'md';
}

export function EstimateStatusBadge({ status, size = 'md' }: EstimateStatusBadgeProps) {
  return (
    <StatusBadge tone={ESTIMATE_STATUS_TONES[status]} size={size}>
      {statusLabels[status]}
    </StatusBadge>
  );
}
